import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import { TagCard } from './';
import { EXCEPTIONS_DETAILS_COLUMNS } from '../../common/chartConstants';
import _ from 'lodash';
import { useTranslation } from "react-i18next";

export default function ExceptionsDetails(props) {

  const { t } = useTranslation();
  const { salesSummaryData, exceptionsSummaryData } = useSelector(state => ({
    salesSummaryData: state.dashboard.salesSummaryData,
    exceptionsSummaryData: state.dashboard.exceptionsSummaryData,
  }));
   const sellerId = useSelector(state => 
    state.dashboard.territoryData && state.dashboard.territoryData.sellerId
  );
  const showExceptionsDetails = (label, totals) => {
    const { handleHealthCheckLabelClick } = props;
    if(!disabledBtn(label)) {
      if (label === 'offDay') {
        handleHealthCheckLabelClick(label, totals, { orderType: 'offDay' });
      } else if (label === 'underMin') {
        handleHealthCheckLabelClick(label, totals, { orderStatus: 'underMin', caseCount: 15 });
      } else {
        handleHealthCheckLabelClick(label, totals);
      }
    }
  };
  const disabledBtn = (label) => {
    // if(salesSummaryData) {
    //   // if (label === 'underMin') { //when underMin tab value is 0, allow click
    //   //   return _.isNull(salesSummaryData[label]);
    //   // }
    //   return _.isNull(salesSummaryData[label]) || salesSummaryData[label] === 0;
    // }
    if(exceptionsSummaryData) {
        if (label === 'underMin') { //when underMin tab value is 0, allow click
          return _.isNull(exceptionsSummaryData[label]);
        }
      return _.isNull(exceptionsSummaryData[label]) || exceptionsSummaryData[label] === 0;
    }
    return true;
  }
  const renderTagCardItems = (startIndex = 0, renderSize = 4) => {
    let keys = ['exactExceptions', 'totalExceptions', 'subsExceptions', 'offDay', 'afterCutOff', 'underMin'];
    if (sellerId !== 'USBL') {
      keys = keys.filter(key => key !== 'offDay');
    }
    return keys.slice(startIndex, startIndex + renderSize).map((key) => {
      const title = EXCEPTIONS_DETAILS_COLUMNS[key];
      let className='primary-card';
      if(title === 'Errored Lines') className='orange-card';
      if(exceptionsSummaryData.hasOwnProperty(key)) {
        const count = exceptionsSummaryData[key];
        return (
          <Col key={key} span={5} className="exceptions-details-row">
            <TagCard title={t(`EXCEPTIONS_DETAILS_COLUMNS.${key}`)} className={className} count={count} onClick={() => showExceptionsDetails(key, count)}/>
          </Col>
        );
      }
      return null;
    });
  }

  return (
    <div className="dashboard-exceptions-details">
    <Row justify="space-between">
      {sellerId === 'USBL'
        ? renderTagCardItems(0, 6)
        : renderTagCardItems(0, 3)}
    </Row>

    {/* {sellerId === 'USBL' && (
      <>
        <Row justify="flex-start" style={{width: '100%'}}>{renderTagCardItems(0,4)}</Row>
        <Row justify="flex-start" >{renderTagCardItems(4,2)}</Row>
      </>
    )}
    {sellerId !== 'USBL' && (
      <Row justify="space-between">{renderTagCardItems(0, 3)}</Row>
    )} */}
  </div>
  );

};

ExceptionsDetails.propTypes = {};
ExceptionsDetails.defaultProps = {};
